import { render, staticRenderFns } from "./NavCategorizedProducts.vue?vue&type=template&id=7b59b394&scoped=true"
import script from "./NavCategorizedProducts.vue?vue&type=script&lang=js"
export * from "./NavCategorizedProducts.vue?vue&type=script&lang=js"
import style0 from "./NavCategorizedProducts.vue?vue&type=style&index=0&id=7b59b394&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b59b394",
  null
  
)

export default component.exports